const IMAGE_CROP_DEFAULT_DIMENSIONS = {
  WIDTH: 170,
  HEIGHT: 170,
}

export default IMAGE_CROP_DEFAULT_DIMENSIONS
